import { useEffect, useState } from 'react';
import { apiClient, API_ENDPOINTS } from '../config/api';
import DEFAULT_SETTINGS from '../data/siteContactDefaults.json';

export const useSettings = () => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await apiClient.get(API_ENDPOINTS.SETTINGS);
        if (res.data.success && res.data.settings) {
          setSettings({ ...DEFAULT_SETTINGS, ...res.data.settings });
        }
      } catch (err) {
        // fallback to defaults silently
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  return { settings, setSettings, loading };
};

export default useSettings;

